/**
 * @generated SignedSource<<c196f2a039d1b52e4b67c46dcfb0d613>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type insertColumnButton_nativeIssueTable_InsertColumnButtonInner$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_issueTableColumnPicker_ColumnConfig_view">;
  readonly " $fragmentType": "insertColumnButton_nativeIssueTable_InsertColumnButtonInner";
};
export type insertColumnButton_nativeIssueTable_InsertColumnButtonInner$key = {
  readonly " $data"?: insertColumnButton_nativeIssueTable_InsertColumnButtonInner$data;
  readonly " $fragmentSpreads": FragmentRefs<"insertColumnButton_nativeIssueTable_InsertColumnButtonInner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "insertColumnButton_nativeIssueTable_InsertColumnButtonInner",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_issueTableColumnPicker_ColumnConfig_view"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "3d1927e7dd84d7b6d57bfce1310de013";

export default node;
